<div class="main-container">
  <h2 class="h1-medium">Article References</h2>
  <div class="references-container">
    @for (reference of store.allArticleReferences(); track $index) {
      <div class="reference-container">
        <!-- Icon and text area -->
        <a class="text-content" [href]="reference.url" target="_blank">
          <mat-icon class="link-icon">link</mat-icon>
          <span [title]="reference.url">{{ reference.title || reference.url }}</span>
        </a>
        <!-- Delete button -->
        @if (store.isEditMode()) {
          <button
            class="button-secondary-icon delete-button"
            mat-icon-button
            disableRipple
            [class.section-disabled]="this.store.isPending()"
          >
            <mat-icon class="icon" (click)="deleteReference(reference)">delete</mat-icon>
          </button>
        }
      </div>
    }

    @if (store.isEditMode()) {
      <div [class.section-disabled]="this.store.isPending()">
        <button class="button-secondary" mat-flat-button (click)="addArticle()">Add article</button>
      </div>
    }

    @if (store.articleReferencesToMerge()?.length !== 0) {
      @if (store.isEditMode()) {
        <div class="merged-references-header">Merged article references:</div>
      }

      @for (reference of store.articleReferencesToMerge(); track $index) {
        <div class="reference-container">
          <!-- Icon and text area -->
          <a class="text-content" [href]="reference.url" target="_blank">
            <mat-icon class="link-icon">link</mat-icon>
            <span [title]="reference.url">{{ reference.title || reference.url }}</span>
          </a>
        </div>
      }
    }
  </div>
</div>
